export default "/imgs/investigation-02.png"